import { useEffect, useMemo, useState } from 'react';
import {
    MaterialReactTable,
    //createMRTColumnHelper,
    MRT_EditActionButtons,
    useMaterialReactTable
} from 'material-react-table';
import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip
} from '@mui/material';
import {
    QueryClient,
    QueryClientProvider,
    useMutation,
    useQuery,
    useQueryClient,
} from '@tanstack/react-query';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import PersonAdd from '@mui/icons-material/PersonAdd';
import { mkConfig, generateCsv, download } from 'export-to-csv'; //or use your library of choice here
import axios from 'axios'
import { datetimeUTCPeru, maskPassword } from './helpers/utils'
import React from 'react'
import { useAuth } from "../context/authContext.js"

//const columnHelper = createMRTColumnHelper();

const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
});

const TableUsers = () => {
    //CRUD
    const [validationErrors, setValidationErrors] = useState({});

    //data and fetching state
    const [data, setData] = useState([]);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);

    //table state

    const [columnFilters, setColumnFilters] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    })

    // useEffect(() => {
    //     const fetchData = async () => {
    //         if (!data.length) {
    //             setIsLoading(true);
    //         } else {
    //             setIsRefetching(true);
    //         }

    //         const url = new URL(
    //             `${process.env.REACT_APP_ENDPOINT_ALLUSERS}`,
    //         );
    //         url.searchParams.set(
    //             'start',
    //             `${pagination.pageIndex * pagination.pageSize}`,
    //         );
    //         url.searchParams.set('size', `${pagination.pageSize}`);
    //         url.searchParams.set('filters', JSON.stringify(columnFilters ?? []));
    //         url.searchParams.set('globalFilter', globalFilter ?? '');
    //         url.searchParams.set('sorting', JSON.stringify(sorting ?? []));

    //         try {
    //             //use whatever fetch library you want, fetch, axios, etc
    //             setIsLoading(true);
    //             const token = localStorage.getItem('authToken')
    //             const response = await axios.get(url.href,
    //                 {
    //                     headers: {
    //                         'Authorization': `Bearer ${token}`
    //                     }
    //                 }
    //             )
    //             const json = response.data.response;
    //             setData(json);
    //             setRowCount(json.length);
    //         } catch (error) {
    //             setIsError(true);
    //             console.error(error);
    //             return;
    //         }

    //         setIsError(false);
    //         setIsLoading(false);
    //         setIsRefetching(false);
    //     }
    //     fetchData();
    // },
    //     [
    //         columnFilters,
    //         globalFilter,
    //         pagination.pageIndex,
    //         pagination.pageSize,
    //         sorting
    //     ]
    // )

    /**
     * COLUMNS use MEMO
    */

    const columns = useMemo(() => [
        {
            accessorKey: 'ID',
            header: 'ID',
            size: 40,
            Edit: () => null
        },
        {
            accessorKey: 'username',
            header: 'Usuario',            
            muiEditTextFieldProps: {
                type: 'email',
                required: true,
                error: !!validationErrors?.username,
                helperText: validationErrors?.username,
                onFocus: () => setValidationErrors({
                    ...validationErrors,
                    email: undefined,
                })
            },
            //Edit: ({ cell, renderedCellValue }) => <><p><b>Usuario: </b><br></br>{cell.getValue()}</p></>
        },
        {
            accessorKey: 'password',
            header: 'Contraseña',
            enableEditing: true,
            muiEditTextFieldProps: {
                type: 'text',
                required: true,
                error: !!validationErrors?.password,
                helperText: validationErrors?.password,
                onFocus: () => setValidationErrors({
                    ...validationErrors
                })
            },
            Cell: ({ cell }) => (
                maskPassword({ value: cell.getValue() })
            ),            
        },
        {
            accessorKey: 'superuser',
            header: 'Super usuario',
            Cell: ({ cell }) => (cell.getValue() ? 'Si' : 'No'),
            editVariant: 'select',
            /*editSelectOptions: [
                { value: true, label: 'Si' },
                { value: false, label: 'No'},
            ],*/
            muiEditTextFieldProps: {
                required: true,
                SelectProps: {
                    native: true, // Si deseas usar un select nativo del navegador
                },
                children: [
                    <option key="" value=""></option>,
                    <option key="true" value="true">Si</option>,
                    <option key="false" value="false">No</option>,
                ],
                error: !!validationErrors?.superuser,
                helperText: validationErrors?.superuser,
            }
        },
        {
            accessorKey: 'activated',
            header: 'Activo',
            Cell: ({ cell }) => (cell.getValue() ? 'Si' : 'No'),
            editVariant: 'select',
            /*editSelectOptions: [
                { value: true, label: 'Si' },
                { value: false, label: 'No' },
            ],*/
            muiEditTextFieldProps: {
                required: true,
                SelectProps: {
                    native: true, // Si deseas usar un select nativo del navegador
                },
                children: [
                    <option key="" value=""></option>,
                    <option key="true" value="true">Si</option>,
                    <option key="false" value="false">No</option>,
                ],
                error: !!validationErrors?.activated,
                helperText: validationErrors?.activated
            }
        },
        {
            accessorKey: 'createdAt',
            header: 'Fecha de creación',
            Cell: ({ cell }) => (
                datetimeUTCPeru({ datetime: cell.getValue() })
            ),
            Edit: () => null,
        },
        {
            accessorKey: 'updatedAt',
            header: 'Fecha de ultima actualización',
            Cell: ({ cell }) => (
                datetimeUTCPeru({ datetime: cell.getValue() })
            ),
            size: 140,
            Edit: () => null,
        }
    ], [validationErrors]
    )

    /**
     * CRUD
     */

    //call CREATE hook
    const {
        mutateAsync: createUser,
        isPending: isCreatingUser
    } = useCreateUser();

    //call READ hook
    const {
        data: fetchedUsers = [],
        isError: isLoadingUsersError,
        isFetching: isFetchingUsers,
        isLoading: isLoadingUsers,
    } = useGetUsers();

    //call UPDATE hook
    const {
        mutateAsync: updateUser,
        isPending: isUpdatingUser
    } = useUpdateUser();

    //call DELETE hook
    const {
        mutateAsync: deleteUser,
        isPending: isDeletingUser
    } = useDeleteUser();

    //CREATE action
    const handleCreateUser = async ({ values, table }) => {
        const newValidationErrors = validateUser(values);
        if (Object.values(newValidationErrors).some((error) => error)) {
            setValidationErrors(newValidationErrors);
            return;
        }

        setValidationErrors({});
        await createUser(values);
        table.setCreatingRow(null); //exit creating mode
    };

    //UPDATE action
    const handleSaveUser = async ({ values, table, ...row}) => {
        const newValidationErrors = validateUpdateUser(values);
        if (Object.values(newValidationErrors).some((error) => error)) {
            setValidationErrors(newValidationErrors);
            return;
        }
        setValidationErrors({});
        await updateUser(values);
        table.setEditingRow(null); //exit editing mode
        setPassword('')
    };

    //DELETE action
    const openDeleteConfirmModal = (row) => {
        if (window.confirm('¿Esta seguro de eliminar este usuario?')) {
            deleteUser(row.original.ID)
        }
    };

    /**
     * EXPORTS
     */
    const handleExportRows = (rows) => {
        const rowData = rows.map((row) => row.original);
        const csv = generateCsv(csvConfig)(rowData);
        download(csvConfig)(csv);
    }

    const handleExportData = () => {
        const csv = generateCsv(csvConfig)(data);
        download(csvConfig)(csv);
    }
    const [password, setPassword] = useState('');

    const renderEditRowDialogContent = ({ table, row, internalEditComponents }) => {
    // Estado local para manejar el valor del campo de contraseña        
        
        // Manejar el cambio en el campo de contraseña
        const handlePasswordChange = (event) => {         
            setPassword(event.target.value);
        };

        // Modificar los componentes internos para ajustar el campo de contraseña
        const adjustedComponents = internalEditComponents.map((component, key) => {
            // Si el índice del componente es el del campo de contraseña, clonar y ajustar
            if (key === 2) { // Ajusta el índice según la posición del campo de contraseña
                component.props.cell.row._valuesCache.password = password                
                return React.cloneElement(component, {                    
                    required: false,
                    value: password,
                    onChange: handlePasswordChange,
                });
            }
        
            if (key === 1) { // Ajusta el índice según la posición del campo de contraseña
                return `Usuario: ${component.props.cell.getValue()}`
            }
            
            return component;
        });

        return (
            <>
                <DialogTitle variant="p">
                    Editar usuario: Si no va a cambiar la contraseña, debe dejar el espacio en blanco.
                </DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    {adjustedComponents}
                </DialogContent>
                <DialogActions>
                    <MRT_EditActionButtons variant="text" table={table} row={row} />
                </DialogActions>
            </>
        );
    };

    const table = useMaterialReactTable({
      columns,
      data: fetchedUsers,
      createDisplayMode: "modal",
      editDisplayMode: "modal",
      enableEditing: true,
      getRowId: (row) => row.id,
      muiToolbarAlertBannerProps: isLoadingUsersError
        ? {
            color: "error",
            children: "Error al cargar los datos",
          }
        : undefined,
      muiTableContainerProps: {
        sx: {
          minHeight: "500px",
        },
      },
      onCreatingRowCancel: () => setValidationErrors({}),
      onCreatingRowSave: handleCreateUser,
      onEditingRowCancel: () => setValidationErrors({}),
      onEditingRowSave: handleSaveUser,
      //
      renderCreateRowDialogContent: ({
        table,
        row,
        internalEditComponents,
      }) => (
        <>
          <DialogTitle variant="p">Crear nuevo usuario</DialogTitle>
          <DialogContent
            sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
          >
            {internalEditComponents.filter(
              (value, key) => key !== 0 && key !== 5 && key !== 6
            )}
          </DialogContent>
          <DialogActions>
            <MRT_EditActionButtons variant="text" table={table} row={row} />
          </DialogActions>
        </>
      ),
      renderEditRowDialogContent,
      renderRowActions: ({ row, table }) => (
        <Box sx={{ display: "flex", gap: "1rem" }}>
          <Tooltip title="Editar">
            <IconButton onClick={() => table.setEditingRow(row)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton
              color="error"
              onClick={() => openDeleteConfirmModal(row)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
      //
      enableRowSelection: false,
      columnFilterDisplayMode: "popover",
      paginationDisplayMode: "pages",
      positionToolbarAlertBanner: "bottom",
      renderTopToolbarCustomActions: ({ table }) => (
        <Box
          sx={{
            display: "flex",
            gap: "16px",
            padding: "8px",
            flexWrap: "wrap",
          }}
        >
          <Button
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => {
              table.setCreatingRow(true);
            }}
            startIcon={<PersonAdd />}
          >
            Crear usuario
          </Button>
          <Button
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={handleExportData}
            startIcon={<FileDownloadIcon />}
          >
            Exportar
          </Button>         
        </Box>
      ),
      state: {
        isLoading: isLoadingUsers,
        isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
        showAlertBanner: isLoadingUsersError,
        showProgressBars: isFetchingUsers,
      },
    });

    return <MaterialReactTable table={table} />
}

//CREATE hook (post new user to api)
function useCreateUser() {
    const queryClient = useQueryClient();
    const [errorMessage, setErrorMessage] = useState(null);
    // return useMutation({
    //     mutationFn: async (user) => {            
    //         const token = localStorage.getItem('authToken')
    //         try {
    //             const response = await axios.post(`${process.env.REACT_APP_INSERT_TABLE_USER}`,
    //                 user,
    //                 {
    //                     headers: {
    //                         'Authorization': `Bearer ${token}`
    //                     }
    //                 }
    //             )
    //             alert("Se creó el usuario.")
    //             return response
    //         } catch (error) {
    //             setErrorMessage('Error al crear el usuario, posiblemente este ingresando un usuario que ya existe.');
    //             alert("Error al crear el usuario, posiblemente este ingresando un usuario que ya existe, intente con otro usuario")
    //             return error; // Propagar el error para que React Query lo maneje
    //         }

    //     },
    //     //client side optimistic update
    //     onMutate: (newUserInfo) => {
    //         queryClient.setQueryData(['users'], (prevUser) => [
    //             {
    //                 ...newUserInfo,
    //                 id: (Math.random() + 1).toString(36).substring(7),
    //             },
    //         ]);
    //     },
    //     onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo//refetch users after mutation, disabled for demo
    // });
    return true

}

//READ hook (get users from api)
function useGetUsers() {
    // return useQuery({
    //     queryKey: ['users'],
    //     queryFn: async () => {
    //         const token = localStorage.getItem('authToken')
    //         const response = await axios.get(`${process.env.REACT_APP_ENDPOINT_ALLUSERS}`,
    //             {
    //                 headers: {
    //                     'Authorization': `Bearer ${token}`
    //                 }
    //             }
    //         )
    //         console.log("ALL USER", response.data.response)
    //         return response.data.response;
    //     },
    //     refetchOnWindowFocus: false,
    // });
    return true
}

//UPDATE hook (put user in api)
function useUpdateUser() {
    const queryClient = useQueryClient();
    const [errorMessage, setErrorMessage] = useState(null);
    return useMutation({
        mutationFn: async (user) => {            
            let params = {}
            params.username = user.username
            params.superuser = user.superuser
            params.activated = user.activated
            if (user.password.trim() !== "") params.password = user.password.trim()
            
            const token = localStorage.getItem('authToken')
            try {
                const response = await axios.put(`${process.env.REACT_APP_UPDATE_TABLE_USER}${user.ID}`,
                    params,
                    {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    }
                )
                alert("Se actualizó el usuario.")
                return response
            } catch (error) {
                setErrorMessage('Error al actualizar el usuario, intente nuevamente.')
                alert("Error al actualizar el usuario, intente nuevamente.")
                return error; // Propagar el error para que React Query lo maneje
            }
        },
        //client side optimistic update
        onMutate: (newUserInfo) => {
            queryClient.setQueryData(['users'], (prevUser) => [
                {
                    ...newUserInfo,
                    id: (Math.random() + 1).toString(36).substring(7),
                },
            ]);
        },
        onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
    });
}

//DELETE hook (delete user in api)
function useDeleteUser() {
    const { user, id } = useAuth()
    const queryClient = useQueryClient();
    const [errorMessage, setErrorMessage] = useState(null);
    return useMutation({
        mutationFn: async (idUser) => {
            console.log("Usuario a borrar", idUser, "Usuario actual", id)
            if (idUser == id) {
                alert("No puedes eliminar tu propio usuario")
                return
            } else {
                console.log(id)
                console.log("DATA DELETE:", idUser) 
                const token = localStorage.getItem('authToken')
                try {
                    console.log(`${process.env.REACT_APP_DELETE_TABLE_USER}${idUser}`)
                    const response = await axios.delete(`${process.env.REACT_APP_DELETE_TABLE_USER}${idUser}`,
                        {
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        }
                    )
                    alert("Se eliminó el usuario.")
                    return response
                } catch (error) {
                    setErrorMessage('Error al eliminar el usuario, intente nuevamente.')
                    alert("Error al eliminar el usuario, intente nuevamente.")
                    return error;
                }
            }
        },
        //client side optimistic update
        onMutate: (userId) => {
            queryClient.setQueryData(['users'], (prevUsers) =>
                prevUsers?.filter((user) => user.id !== userId),
            );
        },
        onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
    });
}

const queryClient = new QueryClient();

const TableUsersWithProviders = () => (
    //Put this with your other react-query providers near root of your app
    <QueryClientProvider client={queryClient}>
        <TableUsers />
    </QueryClientProvider>
);

export default TableUsersWithProviders;

const validateRequiredSelect = (value) => {
    return value === "" ? true : false
};
const validateRequired = (value) => !!value.length;

const validateEmail = (email) => !!email.length && email
    .toLowerCase()
    .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

function validateUser(user) {
    return {
        username: !validateEmail(user.username) ? 'Ingrese un email valido' : '',
        password: !validateRequired(user.password) ? 'Ingrese una contraseña' : '',
        superuser: validateRequiredSelect(user.superuser) ? 'Seleccione una opción' : '',
        activated: validateRequiredSelect(user.activated) ? 'Seleccione una opción' : '',
    };
}

function validateUpdateUser(user) {
    return {
        username: !validateEmail(user.username) ? 'Ingrese un email valido' : '',
        superuser: validateRequiredSelect(user.superuser) ? 'Seleccione una opción' : '',
        activated: validateRequiredSelect(user.activated) ? 'Seleccione una opción' : '',
    };
}